import {
  type SanityProductGalleryPhoto,
  type SanityProductVariantFragment,
} from '@data/sanity/queries/types/product'
import { getProductGalleryPhotos } from '@lib/product/images'

import Gallery, { type GalleryProps } from '@blocks/gallery'

type ProductGalleryProps = Pick<
  GalleryProps,
  | 'hasArrows'
  | 'hasDots'
  | 'hasDrag'
  | 'hasCounter'
  | 'hasThumbnails'
  | 'preloadFirstPhoto'
> & {
  photosets: SanityProductGalleryPhoto[]
  activeVariant?: SanityProductVariantFragment
  previewVariant?: SanityProductVariantFragment
}

const ProductGallery = ({
  photosets,
  activeVariant,
  previewVariant,
  hasArrows = false,
  hasDots = false,
  hasDrag = false,
  hasCounter = false,
  hasThumbnails = false,
  preloadFirstPhoto = false,
}: ProductGalleryProps) => {
  // Get preview variant photos or active variant photos
  const previewVariantPhotos = previewVariant
    ? getProductGalleryPhotos(photosets, previewVariant)
    : []
  const photos =
    previewVariantPhotos.length > 0
      ? previewVariantPhotos
      : getProductGalleryPhotos(photosets, activeVariant)

  return (
    <Gallery
      photos={photos}
      hasArrows={hasArrows}
      hasDots={hasDots}
      hasDrag={hasDrag}
      hasCounter={hasCounter}
      hasThumbnails={hasThumbnails}
      preloadFirstPhoto={preloadFirstPhoto}
    />
  )
}

export default ProductGallery
